import styled from 'styled-components';

import { BREAK_POINTS, Colors, Text } from '@origin-digital/style-guide';

export const Porthole = styled.div`
  width: 56px;
  height: 56px;
  margin-right: 16px;
  display: none;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    display: block;
    width: 128px;
    height: 128px;
    margin-right: 0;
    margin-bottom: 32px;
  }

  border-radius: 50%;
  background-color: ${Colors.GREY4};
  position: relative;
  overflow: hidden;

  & > * {
    width: 100%;
    height: 100%;
  }
`;

export const MultiChoiceIndicator = styled.div`
  border: 1px solid ${Colors.GREY80};
  width: 20px;
  height: 20px;
  margin-right: 16px;
  margin-top: 2px;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    align-self: flex-start;
    position: absolute;
    left: 16px;
    top: 16px;
    margin-top: 0;
  }

  svg {
    display: none;
  }
`;

export const FauxInput = styled.div`
  display: inline-block;
  position: relative;
  padding: 16px 24px;
  background: ${Colors.WHITE};
  border: 2px solid ${Colors.GREY16};
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;

  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    flex-direction: column;
    padding: 32px 16px;
    max-width: 220px;
    flex-grow: 1;
    align-items: center;
  }
`;

export const CheckboxText = styled(Text)`
  text-align: center;
  @media screen and (max-width: ${BREAK_POINTS.Max.MD}) {
    text-align: left;
    font-size: 16px;
  }
`;

export const Label = styled.label`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  cursor: pointer;
`;

export const HiddenInput = styled.input`
  left: -9999px;
  position: absolute;
  opacity: 0;
  width: 0;
  margin-right: 0;

  &:focus + ${FauxInput} {
    outline: 2px solid ${Colors.GREY16};
  }
  &:checked:focus,
  &:checked:hover,
  &:checked:active {
    & + ${FauxInput} {
      outline: 2px solid #ffe7be;
    }
  }
  &:checked + ${FauxInput} {
    border: 2px solid #ffc72c;

    ${MultiChoiceIndicator} {
      border-color: ${Colors.LIGHT_ORANGE};
      background: ${Colors.LIGHT_ORANGE};
      svg {
        display: block;
      }
    }
  }
  &:disabled + ${FauxInput} {
    opacity: 0.5;

    ${Label} {
      cursor: not-allowed;
    }
  }
`;
